import { Outlet } from 'react-router-dom';

import { RouteErrorBoundary } from '@/shared/components/RouteErrorBoundary';

import { PumsemFooter } from '../../components/PumsemFooter';
import { PumsemManageHeader } from '../../components/PumsemManageHeader';

/**
 * 관리 화면 셸.
 *
 * 열람 셸(`PumsemLayoutView`)을 재사용하지 않는다 — 그쪽은 좌측 결과 목록이
 * 본문 폭을 잡아먹고, 관리자는 검색이 아니라 트리로 항목을 찾는다.
 * 반대로 마케팅 레이아웃도 안 쓴다: 메가메뉴와 사업자 정보 푸터가 붙으면
 * 관리 중에 다른 사이트로 넘어온 것처럼 보인다.
 *
 * 그래서 **품셈해설의 헤더·푸터는 그대로 두고 가운데만 비운다.**
 */
export function PumsemManageLayoutView() {
  return (
    <div className="flex min-h-screen flex-col">
      <PumsemManageHeader />
      <div className="flex-1">
        <RouteErrorBoundary label="품셈해설 관리">
          <Outlet />
        </RouteErrorBoundary>
      </div>
      <PumsemFooter />
    </div>
  );
}
